/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = File
 *
 * 1 = Form
 */
export enum PerformanceReviewType {
  File = 0,
  Form = 1,
}
